/* DSL Review photo — preview + size-check */
(function(){
  document.addEventListener("change", function(e){
    if (!e.target.matches("[data-review-photo]")) return;
    var file = e.target.files[0];
    var preview = document.querySelector("[data-review-photo-preview]");
    if (!file) { preview.hidden = true; return; }
    if (file.size > 3 * 1024 * 1024) {
      if (window.DSL_BANNER) window.DSL_BANNER.show({text: "Foto te groot (max 3 MB).", variant: "error"});
      e.target.value = "";
      preview.hidden = true;
      return;
    }
    var reader = new FileReader();
    reader.onload = function(ev){
      preview.innerHTML = "<img src=\"" + ev.target.result + "\" alt=\"\" style=\"max-width:200px;max-height:200px\">";
      preview.hidden = false;
    };
    reader.readAsDataURL(file);
  });
})();